module.exports = __webpack_public_path__ + "static/media/landscape_thumb.d3dc59b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landscape_thumb.jpg
// module id = 314
// module chunks = 0